import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getTodayDate } from '../utils/dateUtils';

interface RestSettings {
  // 目標設定（低めがデフォルト）
  dailyGoalMinutes: number;     // デフォルト: 25分（1ポモドーロ）
  maxDailyMinutes: number;       // デフォルト: 120分（休憩推奨ライン）
  
  // 通知の強さ
  reminderLevel: 'gentle' | 'off';  // デフォルト: gentle
  
  // 休息モード
  isRestMode: boolean;           // 今日は休むモード中
  lastRestDate: string | null;   // 最後に休んだ日
}

interface RestState {
  restSettings: RestSettings;
  restDays: string[];  // 休息した日のリスト
  // Actions
  updateRestSettings: (settings: Partial<RestSettings>) => void;
  setRestMode: (enabled: boolean) => void;
  logRestDay: () => void;
}

const defaultRestSettings: RestSettings = {
  dailyGoalMinutes: 25,        // たった1ポモドーロでOK！
  maxDailyMinutes: 120,         // 2時間超えたら心配
  reminderLevel: 'gentle',
  isRestMode: false,
  lastRestDate: null
};

export const useRestStore = create<RestState>()(
  persist(
    (set) => ({
      restSettings: defaultRestSettings,
      restDays: [],
      
      updateRestSettings: (settings) =>
        set((state) => ({
          restSettings: { ...state.restSettings, ...settings },
        })),
      
      setRestMode: (enabled) => {
        const today = getTodayDate();
        set((state) => ({
          restSettings: {
            ...state.restSettings,
            isRestMode: enabled,
            lastRestDate: enabled ? today : state.restSettings.lastRestDate,
          },
        }));
      },
      
      logRestDay: () => {
        const today = getTodayDate();
        set((state) => ({
          restDays: [...new Set([...state.restDays, today])],
        }));
      },
    }),
    {
      name: 'sorarium-rest-storage',
      partialize: (state) => ({
        restSettings: state.restSettings,
        restDays: state.restDays,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          // 日付が変わったら休息モードを解除
          const today = getTodayDate();
          if (state.restSettings.lastRestDate !== today) {
            state.restSettings.isRestMode = false;
          }
        }
      },
    }
  )
);